import store from "@/app/app-state";
import { PanelNotifications } from "@/app/shared/services";

const RouterHooks = {
    setApplicationFavicon: (to, from, next) => {
        const settings = store.getters.APP_SETTINGS;
        const favicon = document.getElementById("favicon");
        favicon.href = settings.favicon;
        next();
    },
    setApplicationTitle: (to, from, next) => {
        const settings = store.getters.APP_SETTINGS;
        document.title = settings.title;
        next();
    },
    setTestGroup: (to, from, next) => {
        if (to.query.hasOwnProperty("group")) localStorage.setItem("testGroup", to.query.group);
        next();
    },
    enablePaymentsNotifications: (to, from, next) => {
        const user = store.getters.AUTH_USER;
        const settings = store.getters.APP_SETTINGS;
        const openedNotifications = store.getters.OPENED_NOTIFICATIONS;
        if (
            user &&
            user.hasOwnProperty("cc_attached") &&
            !user.cc_attached &&
            settings.payments.enabled &&
            !openedNotifications.noCreditCard
        ) {
            PanelNotifications.noCreditCard.open();
        }

        next();
    },
};

export { RouterHooks };
